import abi from "./abis/ERC721base.json";
import {
  getv,
  iso,
  nils,
  tofeth,
  tofpval,
  toeth,
  base64_to_json,
  blocktime_iso,
} from "@/utils/utils";
import { ethers } from "ethers";
import _ from "lodash";
import { CV2_Contract } from "./cv2_base.js";
import { contractAddress_list } from "@/contracts/contracts.jsx";

const k = "erc721_base";

// NFT contract address mapping - generated from contractAddress_list
const NFT_ADDRESSES = {
  FBIKE: contractAddress_list.fbike,
  FBIKESKIN: contractAddress_list.fbikeskin,
  FACTIONSAGENTS: contractAddress_list.factionsagents,
};

class Contract extends CV2_Contract {
  constructor({ contract_k, contractAddress, aumode, abi, ...ext }) {
    super({ contract_k, contractAddress, aumode, abi, ...ext });
  }

  async getParsedLogs(logs) {
    if (!logs) return [];
    let logrows = [];
    for (let log of logs) {
      let iface = new ethers.Interface(this.abi);
      let par = iface.parseLog(log);
      if (nils(par)) continue;
      let name = par.name;
      let o = {
        name,
        logIndex: log.logIndex,
        hash: log.transactionHash,
        blockNumber: log.blockNumber,
      };
      o.id = `${o.hash}:${o.logIndex}`;
      logrows.push(o);
    }
    return logrows;
  }

  async balanceOf(owner, info = {}) {
    let r = await this.run("balanceOf", [owner], info);
    return r;
  }

  async ownerOf(tokenId, info = {}) {
    let r = await this.run("ownerOf", [tokenId], info);
    return r;
  }

  async approve(to, tokenId, info = {}) {
    let tx = await this.run("approve", [to, tokenId], info);
    return tx;
  }

  async getApproved(tokenId, info = {}) {
    let r = await this.run("getApproved", [tokenId], info);
    return r;
  }

  async setApprovalForAll(operator, approved, info = {}) {
    let tx = await this.run("setApprovalForAll", [operator, approved], info);
    return tx;
  }

  async isApprovedForAll(owner, operator, info = {}) {
    let r = await this.run("isApprovedForAll", [owner, operator], info);
    return r;
  }

  async transferFrom(from, to, tokenId, info = {}) {
    let tx = await this.run("transferFrom", [from, to, tokenId], info);
    return tx;
  }

  async safeTransferFrom(from, to, tokenId, data = "0x", info = {}) {
    let tx = await this.run(
      "safeTransferFrom",
      [from, to, tokenId, data],
      info,
    );
    return tx;
  }

  async tokenURI(tokenId, info = {}) {
    let r = await this.run("tokenURI", [tokenId], info);
    return r;
  }

  async totalSupply(info = {}) {
    let r = await this.run("totalSupply", [], info);
    return r;
  }

  async tokenByIndex(index, info = {}) {
    let r = await this.run("tokenByIndex", [index], info);
    return r;
  }

  async tokenOfOwnerByIndex(owner, index, info = {}) {
    let r = await this.run("tokenOfOwnerByIndex", [owner, index], info);
    return r;
  }
}

const get_contract_address = (nftSymbol) => {
  if (nftSymbol.startsWith("0x")) return nftSymbol;
  const address = NFT_ADDRESSES[nftSymbol.toUpperCase()];
  if (!address) {
    throw new Error(`NFT contract address not found for symbol: ${nftSymbol}`);
  }
  return address;
};

const get_contract = async (nftSymbol, ext = {}) => {
  const contractAddress = get_contract_address(nftSymbol);
  const runner = new Contract({
    contract_k: `erc721_${nftSymbol.toLowerCase()}`,
    contractAddress,
    aumode: ext.aumode || "thirdweb",
    abi,
    ...ext,
  });
  return runner;
};

// Helper function to add new NFT contract addresses
const addNftAddress = (symbol, address) => {
  NFT_ADDRESSES[symbol.toUpperCase()] = address;
};

// Helper function to get all supported NFT contracts
const getSupportedNfts = () => {
  return Object.keys(NFT_ADDRESSES);
};

const ERC721base = {
  k,
  get_contract,
  get_contract_address,
  addNftAddress,
  getSupportedNfts,
  NFT_ADDRESSES,
};

export default ERC721base;
